var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/height-yt1.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("亚太1-4类团意险普通医疗版（非高空）")]),
                  _c("div", [
                    _vm._v("高性价比 | 亚太财产保险有限公司承保 | 全线上操作"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 1-4类工种覆盖广\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 投保简便支持月单\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t③ 社保用药100%赔付\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t④ 3人起保，性价比高\n\t\t\t\t"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载亚太职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataPlan,
                        option: _vm.optionPlan,
                        "span-method": _vm.spanMethodPlan,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t社保用药 100%赔付，伤残等级对应赔付比例请查看附表\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: { data: _vm.dataBenefit, option: _vm.optionBenefit },
                  }),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { column: 1, border: "", title: "注意事项" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "起保人数" } }, [
                    _vm._v("\n\t\t\t\t\t一份保单须投保\n\t\t\t\t\t"),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("3人以上"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c("span", [_vm._v(_vm._s(qa.answer))]),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("h3", [_vm._v("保险条款及须知")]),
                    _c("p", { staticStyle: { "line-height": "32px" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t1、本保险适用以下保险条款\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t2、本产品由亚太财产保险有限公司（以下简称“亚太财险”）承保，目前在山东、青岛、广东、河北、河南、北京、浙江、安徽、四川、湖北、内蒙古、辽宁（除大连）、上海、福建、江苏、湖南、天津、陕西、海南、重庆、云南、深圳、宁波设有分支机构。本产品的销售区域为全国。对亚太财险未设立分支机构的地区，可能会存在服务不到位、时效差的问题，但亚太财险会在用户服务和时效上提供竭力保障，任何疑问可拨打亚太财险7*24小时客服服务热线95506。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：\n\t\t\t\t\t\t4、保险公司全国统一的客户服务及投诉方式详见如下链接：\n\t\t\t\t\t\t5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t7、保费支付：本产品支持使用网上银行、微信、支付宝进行保费支付。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t8、本产品为您提供电子保单，根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。为保证您的合法权益，您可拨打亚太财险客服热线95506查询保单信息或验证保单，或登录www.apiins.com进行自助保单验真。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t9、本产品自动核保，投保成功后，亚太财险将向您预留的手机发送承保短信/电子保单，请注意查收。此外，您可关注“亚太财险”微信公众号申请电子发票，电子发票是以电子方式存储的收付款凭证，其法律效力、基本用途、基本使用规定等与税务机关监制的纸质发票相同。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t10、退保规则：保险责任生效之后退保，保险公司仅退还保单未满期净保费。未满期净保费=保险费（1-20%）×（1-保险责任已经过的天数/保险期间的天数)×100%，经过天数不足一天的按一天计算。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t11、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t"
                      ),
                      _c("br"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }